import React, { useEffect, useState } from 'react';
import T from 'prop-types';
import cx from 'classnames';

import LoadingSpinner from './LoadingSpinner';

const IOSToggleButton = ({
  checked,
  disabled,
  inputID = 'toggle-input',
  inputClass = '',
  onChange,
}) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (loading) {
      setLoading(false);
    }
  }, [checked]);

  const handleChange = ({ target }) => {
    setLoading(true);
    onChange(target.checked);
  };

  return (
    <div className={cx('h-state-wrapper', { 'state-default': !loading, 'state-loading': loading })}>
      <div className="d-inline-block v-a-m pos-rel">
        <input
          className={`switch ${inputClass}`}
          type="checkbox"
          disabled={disabled}
          checked={checked}
          id={inputID}
          onChange={handleChange}
        />
        <label className="switch-btn" htmlFor={inputID} />
        <div className="h-state-loading center-x-y pin-loader">
          <div className="flex-grid">
            <div className="flex-cell text-center">
              <LoadingSpinner size="sm" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

IOSToggleButton.propTypes = {
  checked: T.bool.isRequired,
  disabled: T.bool,
  inputID: T.string,
  inputClass: T.string,
  onChange: T.func.isRequired,
};

export default IOSToggleButton;
